import { useEffect, useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Overline, SectionTitle } from "./Reveal";

const SHOTS = [
  ["1-today", "Your workout, your choice"],
  ["3-chooser", "Gym, hike, Pilates or rest day"],
  ["7-library", "225 exercises with videos"],
  ["4-exercise", "Know exactly what to lift"],
  ["5-diary", "Track food the easy way"],
  ["6-progress", "Watch yourself progress"],
];

const useIsDesktop = () => {
  const [d, setD] = useState(() => window.matchMedia("(min-width: 1024px)").matches);
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1024px)");
    const on = (e) => setD(e.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return d;
};

const Card = ({ id, alt, i }) => (
  <figure data-testid={`showcase-card-${id}`} className="relative shrink-0 snap-center overflow-hidden rounded-[1.75rem] border border-white/[0.08] bg-[#16181f] shadow-[0_40px_80px_-40px_rgba(0,0,0,0.9)]">
    <img src={`/images/store-${id}.webp`} alt={alt} loading="lazy" className="block aspect-[9/16] h-[520px] w-auto object-cover sm:h-[560px] lg:h-[68vh]" />
    <span className="absolute left-4 top-4 rounded-full bg-black/50 px-2.5 py-1 font-mono-x text-[10px] text-[#c4c8cf] backdrop-blur">0{i + 1}</span>
  </figure>
);

export const Showcase = () => {
  const ref = useRef(null);
  const track = useRef(null);
  const [dist, setDist] = useState(0);
  const desktop = useIsDesktop();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });
  const x = useTransform(scrollYProgress, [0.05, 0.95], [0, -dist]);

  useEffect(() => {
    const measure = () => setDist(Math.max(0, (track.current?.scrollWidth ?? 0) - window.innerWidth + 64));
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, [desktop]);

  return (
    <section id="showcase" ref={ref} data-testid="showcase-section" className={desktop ? "relative h-[280vh]" : "relative py-24"}>
      <div className={desktop ? "sticky top-0 flex h-screen flex-col justify-center overflow-hidden pt-16" : ""}>
        <div className="mx-auto w-full max-w-7xl px-5 sm:px-8">
          <Reveal><Overline>Swipe through Spotter</Overline><SectionTitle className="mt-4">Your plan. <span className="text-grad">Your call.</span></SectionTitle></Reveal>
        </div>
        <motion.div
          ref={track}
          style={desktop ? { x } : undefined}
          className={`mt-10 flex gap-6 px-5 sm:px-8 lg:gap-8 lg:pl-[max(2rem,calc((100vw-80rem)/2+2rem))] ${desktop ? "w-max" : "no-scrollbar snap-x snap-mandatory overflow-x-auto pb-4"}`}
        >
          {SHOTS.map(([id, alt], i) => <Card key={id} id={id} alt={alt} i={i} />)}
        </motion.div>
      </div>
    </section>
  );
};
